import React, { useRef } from "react";
import { Grid, Typography, Box } from "@mui/material";
import profileData from "../../../profileData";
import hola from "../../../images/encanto_greeting.png";
import { useInView, motion } from "framer-motion";
import "../Home.css";
import "../../../App.css";

const Banner = () => {
  const greetingContent = useRef(null);
  const greetingContentIsInView = useInView(greetingContent, { once: true });
  const greetingImage = useRef(null);
  const greetingImageIsInView = useInView(greetingImage, { once: true });
  return (
    <Box id="Banner-Container">
      <Grid id="Banner-Content" container spacing={{ md: 2 }}>
        <Grid
          item
          xs={12}
          md={8}
          id="greeting_content"
          //sx={{ marginTop: "2rem !important" }}
          ref={greetingContent}
          className={`margin-top ${
            greetingContentIsInView ? "inview-from-left" : "animate-from-left"
          }`}
        >
          <Typography variant="h1">Hey there👋🏼 </Typography>
          <Typography variant="h1">I'm Niveditha! </Typography>
          <Typography variant="body1">{profileData.bio}</Typography>
          <Typography variant="body2">{profileData.hashtag}</Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          id="greeting_image"
          ref={greetingImage}
        >
          <motion.img src={hola} width="90%" height="90%" alt="Hello!" initial={{scale:0}} animate={greetingImageIsInView? {scale:1}:""} transition={{duration:1}}/>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Banner;
